


















































































































































































































































































































































































































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { ChecklistSettings } from '@/api/model/checklist-settings'

@Component
export default class EditChecklistSettingsForm extends Vue {
    @Prop({ required: true }) settings!: ChecklistSettings
}
